import { useSetRecoilState } from "recoil";
import AnswersAPI from "../api/answers";
import { answersAtom } from "../atoms/answers.atom";

const useAnswersAction = () => {
  const setConcepts = useSetRecoilState(answersAtom);

  const getAnswers = async(data, cb)=>{
    setConcepts((prevValues) => ({ ...prevValues, loading: true }));
    try {
      const response = await AnswersAPI.getAnswers(data);
      if (cb) {
        cb(response.data);
      }
      setConcepts(() => ({
        answers: response.data,
        loading: false,
        status: response.status,
      }));
    } catch (error) {
      setConcepts((prevValues) => ({
        ...prevValues,
        loading: false,
        message: "Error al obtener respuestas",
        status: 500,
        error: JSON.stringify(error),
      }));
    }
  };

  const resetAnswers = async()=>{
    setConcepts((prevValues) => ({
      ...prevValues,
      answers: null,
      loading: false,
    }));
  }

  return { getAnswers, resetAnswers };
};

export {useAnswersAction}
